export default __webpack_public_path__ + "static/media/27-LazySummer.e15d3e98.jpeg";